import { useState, useEffect } from "react";
import { getAuth, onAuthStateChanged, User } from "firebase/auth";

interface AuthState {
    user: User | null;
    loading: boolean;
}

export const useAuth = () => {
    const [state, setState] = useState<AuthState>({
        user: null,
        loading: true,
    });

    useEffect(() => {
        const auth = getAuth();
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            setState({
                user,
                loading: false,
            });
        });

        return () => unsubscribe();
    }, []);

    return state;
};
